import * as React from 'react'
import {connect} from 'react-redux'
import {Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import {ApplicationState} from "src/store";
import {ProductFamilyIconsInner, Product, UsedMainCategoriesInner} from "src/services/api";
import {
    selectConfigurePageAction,
    selectContractPageAction,
    selectMainPageAction,
    selectOfferPageAction,
} from "App/routes";
import {WithTranslation, withTranslation} from "react-i18next";
import {ApiErrorType, ContactType} from "App/constants";
import {AuthState, cancelLogin, resetLogin} from "App/services/reducers/auth";
import {UserState} from "App/user";
import {
    getSelectedMainCategoryData,
    getSelectedProductData,
    getSelectedSubCategoryData,
    login,
    selectAccount,
    subscribe,
    resetpassword,
    logout
} from "App/services";
import {cancelSubscribe, startSubscribe, SubscribeState} from "App/services/reducers/subscribe";
import {cancelResetPassword, startResetPassword, ResetPasswordState} from "App/services/reducers/resetpassword";
import {contactFormChange, ContactData} from 'App/contactData';
import {computeAllowSubmit, ContactForm, validateForm} from "Components/ContactForm";
import {AsyncButton} from "Components/AsyncButton";

enum Field {
    USERNAME = 'username',
    PASSWORD = 'password'
}

interface ComponentProps {
    contactData: ContactData
    currentPath: string |null
    categoryData: UsedMainCategoriesInner | null
    subcategoryData: ProductFamilyIconsInner |null
    productData: Product |null
    auth: AuthState | null
    subscribe: SubscribeState | null
    resetpassword: ResetPasswordState | null
    allowSubmit: boolean
}

interface StateToProps {
    user: UserState | null
}

interface DispatchToProps {
    onClick: (action:any) => void
    onLogin: (username:string, pwd:string) => void
    onLogout: (refresh: () => any) => void
    onContactChange: (data:Object) => void
    onSubscribe: () => void
    onResetPassword: (username:string) => void
    onIdentity: (authtenticationtoken:string, accountId:string, refresh: () => any) => void
    resetLogin: () => void
}

const mapStateToProps = (state: ApplicationState, props: StateToProps): ComponentProps => ({
    contactData: state.contactData,
    currentPath: state.location?state.location.pathname:null,
    categoryData: getSelectedMainCategoryData(state.data),
    subcategoryData: getSelectedSubCategoryData(state.data),
    productData: getSelectedProductData(state.data),
    auth: state.data.auth,
    subscribe: state.data.subscribe,
    resetpassword: state.data.resetpassword,
    allowSubmit: computeAllowSubmit({...props, type:ContactType.SUBSCRIBE, contactData: state.contactData})
});

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
    onClick: (action) => dispatch(action),
    onLogin: (username:string, pwd:string) => dispatch(login(username,pwd)),
    onLogout: (refresh: () => any) => dispatch(logout(refresh)),
    onContactChange: (data:Object) => dispatch(contactFormChange(data)),
    onSubscribe: () => dispatch(subscribe()),
    onResetPassword: (username:string) => dispatch(resetpassword(username)),
    onIdentity: (authtenticationtoken:string, accountId:string, refresh: () => any) => dispatch(selectAccount(authtenticationtoken, accountId, refresh)),
    resetLogin: () => dispatch(resetLogin())
});

interface ComponentState {
    username?: string
    password?: string
}

function initialState (props: StateToProps): ComponentState {
    return {}
}

class _Module extends React.PureComponent<DispatchToProps & StateToProps & ComponentProps & WithTranslation, ComponentState> {

    constructor(props: DispatchToProps & StateToProps & ComponentProps & WithTranslation, context: any) {
        super(props, context);
        this.state = initialState(props);
        this.changeCredentials = this.changeCredentials.bind(this);
        this.performLogin = this.performLogin.bind(this);
    }

    changeCredentials(field:Field, value:string) {
        const { resetLogin } = this.props;
        this.setState({[field]: value});
        resetLogin()
    }

    performLogout() {
        const { onLogout } = this.props;
        // Go to main after logout
        onLogout(() => selectMainPageAction());
        /* This was an example of refresh for the current page
        onLogout(currentPath && currentPath === "/contract"? () => selectContractPageAction():
            currentPath && currentPath === "/offer"? () => selectOfferPageAction():
                categoryData && subcategoryData && productData?() => selectConfigurePageAction(categoryData.id, subcategoryData.id, productData.id):
                    () => {});*/
    }

    performLogin() {
        const { onLogin } = this.props;
        this.state.username && this.state.password && onLogin(this.state.username, this.state.password);
    }

    render() {
        const { t, contactData, user, categoryData, subcategoryData, productData, onClick, onSubscribe, onResetPassword, onIdentity, currentPath, auth, subscribe, resetpassword, allowSubmit } = this.props;

        function coalesce(elements: any[], nullvalue: any): any[] {
            return elements&&elements.length?elements:[nullvalue];
        }

        // @ts-ignore
        return subscribe && !subscribe.subscribed?
            (
                <Modal isOpen={true} className={"modal-lg contact-dialog mt-6"}>
                    <ModalHeader>
                        <div className={"title-normal-uppercase"}>{t('products.configuration.subscribetitle')}</div>
                    </ModalHeader>
                    <ModalBody className={"pt-1"}>
                        <ContactForm user={user} type={ContactType.SUBSCRIBE} contactData={contactData}/>
                    </ModalBody>
                    <ModalFooter>
                        <AsyncButton disabled={contactData.formSubmitting} iconClassName={"far fa-edit"}
                                     labelTKey={contactData.formSubmitted?'products.configuration.close':'products.configuration.cancel'}
                                     onSubmit={() => onClick(cancelSubscribe())}/>
                        {contactData.formSubmitted ?
                            null:
                            <AsyncButton disabled={!allowSubmit||subscribe.error!==ApiErrorType.NONE}
                                         iconClassName={"far fa-check-circle"} buttonClassName={'primary'}
                                         submitting={contactData.formSubmitting} labelTKey={'products.configuration.subscribe'}
                                         onSubmit={() => validateForm({...this.props, type:ContactType.SUBSCRIBE})&&onSubscribe()}/>
                        }
                    </ModalFooter>
                </Modal>):
            resetpassword?
            (
                <Modal isOpen={true}>
                    <ModalHeader>
                        <div className={"title-normal-uppercase"}>{t('products.configuration.resetpasswordtitle')}</div>
                    </ModalHeader>
                    <ModalBody className={"pt-1"}>
                        <Label className={"py-2 m-0"}>{t(resetpassword.reset?'products.configuration.resetpasswordsuccess':'products.configuration.resetpasswordtext')}</Label>
                        <Form>
                            <FormGroup className={"mb-0"}>
                                {resetpassword.reset || resetpassword.submitting ?
                                    <Label className={"text-normal-details"}>{this.state[Field.USERNAME]}</Label>:
                                    <React.Fragment>
                                        <label htmlFor={Field.USERNAME}
                                               className={"form-label mb-1 show"}>{t('products.configuration.' + Field.USERNAME)}</label>
                                        <Input type={"email"} id={Field.USERNAME} name={Field.USERNAME}
                                           placeholder={t('products.configuration.enter' + Field.USERNAME)}
                                           value={this.state[Field.USERNAME]}
                                           className="form-control text-normal-details form-control-lg"
                                           onChange={(e) => this.changeCredentials(Field.USERNAME, e.target.value)}/>
                                    </React.Fragment>
                                }
                            </FormGroup>
                            <Label className={"pt-2 m-0 w-100 error-message " + (resetpassword.error===ApiErrorType.NONE?'hide':'')}>{t('products.configuration.' + resetpassword.error)}</Label>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <AsyncButton disabled={resetpassword.submitting} iconClassName={"far fa-edit"}
                                     labelTKey={resetpassword.reset?'products.configuration.close':'products.configuration.cancel'}
                                     onSubmit={() => {onClick(cancelResetPassword()); onClick(resetLogin())}}/>
                        {resetpassword.reset ?
                            null :
                            <AsyncButton disabled={!allowSubmit || !this.state[Field.USERNAME] || resetpassword.error !== ApiErrorType.NONE}
                                         iconClassName={"far fa-check-circle"} buttonClassName={'primary'}
                                         submitting={resetpassword.submitting}
                                         labelTKey={'products.configuration.resetpasswordaction'}
                                         onSubmit={() => onResetPassword(this.state[Field.USERNAME]||'')}/>
                        }
                    </ModalFooter>
                </Modal>):
            (
                auth && !auth.done ?
                    <Modal isOpen={true}>
                        <ModalHeader>
                            <div className={"title-normal-uppercase"}>{t(auth.authentication?'products.configuration.chooseaccount':(user?'products.configuration.changeuser':'products.configuration.login'))}</div>
                        </ModalHeader>
                        <ModalBody className={"pt-1"}>
                            {auth.authentication?
                                <Form>
                                    {
                                        coalesce(Object.keys(auth.authentication.accounts)
                                            .filter(key => auth.authentication&&auth.authentication.accounts[key]&&auth.authentication.accounts[key].role.match(/^customer-emplyoee|customer-admin$/))
                                            .map(function(key, index) {
                                                var account = auth.authentication&&auth.authentication.accounts[key];
                                                return account?
                                                    <Button key={key} className="configure text-left w-100 mx-0 mt-2 noheight"
                                                            onClick={() => auth.authentication&&onIdentity(auth.authentication.authtenticationtoken, key,
                                                                currentPath && currentPath === "/contract"? () => selectContractPageAction():
                                                                    currentPath && currentPath === "/offer"? () => selectOfferPageAction():
                                                                        categoryData && subcategoryData && productData?() => selectConfigurePageAction(categoryData.id, subcategoryData.id, productData.id):
                                                                            () => {}
                                                            )}>
                                                        <Row className={"mb-0"}>
                                                            <Col className={"col-1"}><i className="far fa-user pr-2"></i></Col>
                                                            <Col className={"col-11"}>
                                                                <div>{account.identity.firstname + ' ' + account.identity.lastname}</div>
                                                                <div>{t('role.' + account.role)}</div>
                                                            </Col>
                                                        </Row>
                                                    </Button>:null
                                            }), <Label>{t('products.configuration.noaccount')}</Label>)
                                    }
                                </Form> :
                                <Form>
                                    {contactData.subscribed||!!user ?
                                        <Label className={"py-2 m-0"}>{t('products.configuration.logintextsubscribed')}</Label> :
                                        <Label className={"py-2 m-0"}>{t('products.configuration.logintextprefix')}<span
                                            className="action pl-1" onClick={() => {
                                            onClick(cancelLogin());
                                            onClick(startSubscribe())
                                        }}>{t('products.configuration.logintextaction')}</span>{t('products.configuration.logintextsuffix')}
                                        </Label>
                                    }
                                    <FormGroup className={"mb-0"}>
                                        <label htmlFor={Field.USERNAME}
                                               className={"form-label mb-1 show"}>{t('products.configuration.' + Field.USERNAME)}</label>
                                        <Input type={"email"} id={Field.USERNAME} name={Field.USERNAME}
                                               placeholder={t('products.configuration.enter' + Field.USERNAME)}
                                               value={this.state[Field.USERNAME]}
                                               className="form-control text-normal-details form-control-lg"
                                               onChange={(e) => this.changeCredentials(Field.USERNAME, e.target.value)}
                                               onKeyPress={(e) => {
                                                   if(e.key === 'Enter') this.performLogin();
                                               }} />
                                    </FormGroup>
                                    <FormGroup className={"mb-0"}>
                                        <label htmlFor={Field.PASSWORD}
                                               className={"form-label mb-1 show" }>{t('products.configuration.' + Field.PASSWORD)}</label>
                                        <Input type={"password"} id={Field.PASSWORD} name={Field.PASSWORD}
                                               placeholder={t('products.configuration.enter' + Field.PASSWORD)}
                                               className="form-control text-normal-details form-control-lg"
                                               value={this.state[Field.PASSWORD]}
                                               onChange={(e) => this.changeCredentials(Field.PASSWORD, e.target.value)}
                                               onKeyPress={(e) => {
                                                   if(e.key === 'Enter') this.performLogin();
                                               }} />
                                    </FormGroup>
                                    <Label className={"pt-2 m-0 w-100 error-message " + (auth.authentication||auth.error===ApiErrorType.NONE?'hide':'')}>{t('products.configuration.' + auth.error)}</Label>
                                    <Label className={"pt-2 m-0"}>
                                        <span className="action" onClick={() => {
                                            onClick(cancelLogin());
                                            onClick(startResetPassword())
                                            }}>{t('products.configuration.forgotpassword')}
                                        </span>
                                    </Label>
                                </Form>
                            }
                        </ModalBody>
                        <ModalFooter>
                            {
                                user?
                                    <AsyncButton iconClassName={"far fa-sign-out"} 
                                    disabled={auth.submitting}
                                    labelTKey={'products.configuration.logout'} onSubmit={() => 
                                        {
                                            this.performLogout();
                                            this.setState({[Field.USERNAME]: undefined});
                                            this.setState({[Field.PASSWORD]: undefined});
                                    }}/>:""
                            }
                            <AsyncButton iconClassName={"far fa-edit"} disabled={auth.submitting}
                                         labelTKey={'products.configuration.cancel'} onSubmit={() => {
                                onClick(cancelLogin());
                                this.setState({[Field.PASSWORD]: undefined})
                            }}/>
                            <AsyncButton disabled={!this.state.username || !this.state.password || (!auth.authentication && auth.error!==ApiErrorType.NONE)}
                                         iconClassName={"far fa-check-circle"} buttonClassName={'primary' + (auth.authentication?'invisible':'')}
                                         submitting={auth.submitting} labelTKey={'products.configuration.login'} onSubmit={() => this.performLogin()}/>
                        </ModalFooter>
                    </Modal>:
                    null
            )
    }
}

export const LoginModule = connect (mapStateToProps, mapDispatchToProps)(withTranslation('common')(_Module));


// WEBPACK FOOTER //
// ./src/containers/LoginModule.tsx